import React from 'react';
import { IconSvgProps } from '@models/common';

const Incognito: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_18358_36)'>
        <path
          d='M11.3333 8.66667C11.8607 8.66667 12.3762 8.82306 12.8148 9.11608C13.2533 9.4091 13.5951 9.82557 13.7969 10.3128C13.9988 10.8001 14.0516 11.3363 13.9487 11.8536C13.8458 12.3709 13.5918 12.846 13.2189 13.219C12.8459 13.5919 12.3708 13.8459 11.8535 13.9488C11.3362 14.0517 10.8 13.9988 10.3128 13.797C9.82549 13.5952 9.40902 13.2534 9.116 12.8149C8.82298 12.3763 8.66658 11.8607 8.66658 11.3333H7.33325C7.333 11.9803 7.09756 12.6051 6.67079 13.0913C6.24403 13.5776 5.65505 13.8921 5.01359 13.9763C4.37213 14.0605 3.72193 13.9086 3.18415 13.5489C2.64637 13.1893 2.25768 12.6464 2.09049 12.0214C1.92331 11.3964 1.98904 10.732 2.27543 10.1518C2.56182 9.57172 3.04934 9.1155 3.64717 8.86817C4.24499 8.62085 4.91234 8.5993 5.52487 8.80753C6.13741 9.01576 6.65336 9.43957 6.97658 10H9.02325C9.25725 9.59444 9.59395 9.25767 9.99948 9.0236C10.405 8.78954 10.865 8.66643 11.3333 8.66667ZM4.66658 10C4.31296 10 3.97382 10.1405 3.72378 10.3905C3.47373 10.6406 3.33325 10.9797 3.33325 11.3333C3.33325 11.687 3.47373 12.0261 3.72378 12.2761C3.97382 12.5262 4.31296 12.6667 4.66658 12.6667C5.02021 12.6667 5.35935 12.5262 5.60939 12.2761C5.85944 12.0261 5.99992 11.687 5.99992 11.3333C5.99992 10.9797 5.85944 10.6406 5.60939 10.3905C5.35935 10.1405 5.02021 10 4.66658 10ZM11.3333 10C10.9796 10 10.6405 10.1405 10.3904 10.3905C10.1404 10.6406 9.99992 10.9797 9.99992 11.3333C9.99992 11.687 10.1404 12.0261 10.3904 12.2761C10.6405 12.5262 10.9796 12.6667 11.3333 12.6667C11.6869 12.6667 12.026 12.5262 12.2761 12.2761C12.5261 12.0261 12.6666 11.687 12.6666 11.3333C12.6666 10.9797 12.5261 10.6406 12.2761 10.3905C12.026 10.1405 11.6869 10 11.3333 10ZM10.6666 2C11.3738 2 12.0521 2.28095 12.5522 2.78105C13.0523 3.28115 13.3333 3.95942 13.3333 4.66667V6.66667H14.6666V8H1.33325V6.66667H2.66659V4.66667C2.66659 3.95942 2.94754 3.28115 3.44763 2.78105C3.94773 2.28095 4.62601 2 5.33325 2H10.6666ZM10.6666 3.33333H5.33325C4.63059 3.33333 3.99992 3.96667 3.99992 4.66667V6.66667H11.9999V4.66667C11.9999 3.964 11.3666 3.33333 10.6666 3.33333Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_18358_36'>
          <rect
            width='16'
            height='16'
            fill='currentColor'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Incognito;
